// extracted by mini-css-extract-plugin
export default {"returns":"Returns_returns__LeEgv","near_footer":"Returns_near_footer__wKRIf"};